import { Routes } from '@angular/router';

import { AlreadyAuthGuard } from './guards/already-auth.guard';
import { AuthGuard } from './guards/auth.guard';
import { meetingRoomGuard } from './guards/meeting-room.guard';
import { mobileRedirectGuard } from './guards/mobile-redirect.guard';

export const routes: Routes = [
  {
    path: '',
    canActivateChild: [mobileRedirectGuard],
    children: [
      {
        path: 'download-app',
        loadComponent: () =>
          import('./pages/download-app/download-app.component').then((m) => m.DownloadAppComponent),
      },
      {
        path: 'openinapp',
        loadComponent: () =>
          import('./pages/openinapp/openinapp.component').then((m) => m.OpeninappComponent),
      },
      {
        path: 'group/qr/:groupId',
        canActivate: [AuthGuard],
        loadComponent: () =>
          import('./pages/group-qr/group-qr.component').then((m) => m.GroupQrComponent),
      },
      {
        path: 'login',
        canActivate: [AlreadyAuthGuard],
        loadComponent: () => import('./pages/login/login.component').then((m) => m.LoginComponent),
      },
      {
        path: '',
        canActivate: [AuthGuard],
        loadComponent: () =>
          import('./layouts/layout/layout.component').then((m) => m.LayoutComponent),
        loadChildren: () => import('./pages/pages.routing').then((m) => m.PagesRouting),
      },
      {
        path: 'meeting/:roomID',
        canActivate: [meetingRoomGuard],
        loadComponent: () =>
          import('./pages/meeting-ui/meeting-ui.component').then((m) => m.MeetingUiComponent),
      },
      {
        path: '**',
        redirectTo: '',
      },
    ],
  },
];
